import es from './i18n/es';
import en from './i18n/en';
import pt from './i18n/pt';

const RESOURCES = {
  es,
  en,
  pt
};

export default RESOURCES;
